import { useTranslation } from 'react-i18next';
import type { ReasonFactorValue } from '@shared/ui';
import { ReasonFactorDialog } from '@shared/ui';

export type WithdrawalDecisionKind = 'APPROVE' | 'REJECT' | 'REQUEST_INFORMATION' | 'RETURN';

const VARIANT = {
  APPROVE: 'default',
  REJECT: 'destructive',
  REQUEST_INFORMATION: 'secondary',
  RETURN: 'outline',
} as const;

interface ComplianceDecisionDialogProps {
  open: boolean;
  decision: WithdrawalDecisionKind | null;
  loading?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (value: ReasonFactorValue) => void;
}

export function ComplianceDecisionDialog({
  open,
  decision,
  loading,
  onOpenChange,
  onConfirm,
}: ComplianceDecisionDialogProps) {
  const { t } = useTranslation('cabinet');
  if (!decision) return null;

  return (
    <ReasonFactorDialog
      open={open}
      title={t(`compliance.decisions.${decision}.title`)}
      description={t(`compliance.decisions.${decision}.description`)}
      confirmLabel={t(`compliance.decisions.${decision}.confirm`)}
      confirmVariant={VARIANT[decision]}
      showLockOwner={decision === 'REJECT'}
      lockOwnerLabel={t('compliance.decisions.REJECT.lockOwner')}
      loading={loading}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
    />
  );
}
